import data from '../sample/data';

function ExperiencePage() {
  return (
    <div className="space-y-6">
      <h2 className="text-2xl font-semibold">Experience</h2>
      <div className="relative pl-6">
        <span className="absolute left-1 top-1 bottom-1 w-px bg-slate-200 dark:bg-white/10" aria-hidden />
        <div className="space-y-6">
          {data.experience.map((item) => (
            <div key={item.id} className="relative">
              <span className="absolute -left-[7px] top-1 w-3 h-3 rounded-full bg-accent" />
              <div className="rounded-xl border border-slate-200 dark:border-white/10 p-4 bg-white dark:bg-white/5 backdrop-blur">
                <div className="flex items-center justify-between gap-2">
                  <h3 className="font-semibold">{item.role} • {item.company}</h3>
                  <span className="text-xs text-slate-600 dark:text-foreground/70">{item.period}</span>
                </div>
                <p className="text-sm text-slate-700 dark:text-foreground/80">{item.summary}</p>
              </div>
            </div>
          ))}
          {data.education && data.education.map((ed) => (
            <div key={ed.id} className="relative">
              <span className="absolute -left-[7px] top-1 w-3 h-3 rounded-full bg-primary" />
              <div className="rounded-xl border border-slate-200 dark:border-white/10 p-4 bg-white dark:bg-white/5 backdrop-blur">
                <div className="flex items-center justify-between gap-2">
                  <h3 className="font-semibold">{ed.degree} • {ed.school}</h3>
                  <span className="text-xs text-slate-600 dark:text-foreground/70">Graduation {ed.graduation}</span>
                </div>
                <p className="text-sm text-slate-700 dark:text-foreground/80">Supervisor: {ed.supervisor}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default ExperiencePage;


